// Main routes configuration for the application
import ApplicationsList from "../modules/applications/ApplicationsList.js";
import ApplicationWizard from "../modules/applications/ApplicationWizard";
import UpdateIncomplete from "modules/applications/components/UpdateIncomplete";
import MainMenu from "modules/main_menu/MainMenu.js";
import MerchantsIndex from "modules/merchants/Index.js";
import MerchantSearch from "modules/merchants/search/Index.js";
import DealsList from "../modules/deals/DealsList.js";
import DealDetails from "../modules/deals/DealDetails.js";
import FinancialMetrics from "../modules/financial-metrics/FinancialMetrics.js";
import RulesPage from "modules/rules/RulesPage.js";

// Main application routes
export const appRoutes = [
  {
    path: "/main-menu",
    name: "Main Menu",
    icon: "ni ni-bullet-list-67 text-primary",
    miniName: "MM",
    layout: "",
    component: <MainMenu />,
    protected: true,
  },
  {
    path: "/wizard/merchant/new",
    name: "New Merchant",
    icon: "ni ni-single-02 text-info",
    miniName: "NM",
    layout: "",
    component: <MerchantsIndex />,
    protected: true,
  },
  {
    path: "/merchants",
    name: "Merchants",
    icon: "ni ni-shop text-warning",
    miniName: "M",
    layout: "",
    component: <MerchantSearch />,
    protected: true,
  }, // New route for the Create component within the tabs
  {
    path: "/merchants/create",
    name: "Create Merchant",
    icon: "ni ni-single-02 text-info",
    miniName: "CM",
    layout: "",
    component: <MerchantsIndex />,
    protected: true,
  },
  {
    path: "/merchants/search",
    name: "Merchant Search",
    icon: "ni ni-zoom-split-in text-info",
    miniName: "MS",
    layout: "",
    component: <MerchantSearch />,
    protected: true,
  },
  {
    path: "/applications",
    name: "Applications",
    icon: "ni ni-check-bold text-success",
    miniName: "A",
    layout: "",
    component: <ApplicationsList />,
    protected: true,
  },
  {
    path: "/wizard/application/new",
    name: "New Application",
    icon: "ni ni-fat-add text-success",
    miniName: "NA",
    layout: "",
    component: <ApplicationWizard />,
    protected: true,
  },
  {
    path: "/wizard/application/update",
    name: "Update Application",
    icon: "ni ni-settings text-success",
    miniName: "UA",
    layout: "",
    component: <UpdateIncomplete />,
    protected: true,
  },
  {
    path: "/deals",
    name: "Deals",
    icon: "ni ni-money-coins text-info",
    miniName: "D",
    layout: "",
    component: <DealsList />,
    protected: true,
  },
  {
    path: "/deals/:dealPublicId",
    name: "Deal Details",
    icon: "ni ni-single-copy-04 text-info",
    miniName: "DD",
    layout: "",
    component: <DealDetails />,
    protected: true,
  },
  {
    path: "/financial-metrics",
    name: "Reports",
    icon: "ni ni-chart-bar-32 text-success",
    miniName: "FM",
    layout: "",
    component: <FinancialMetrics />,
    protected: true,
  },
  {
    path: "/rules",
    name: "Settings",
    icon: "ni ni-settings-gear-65 text-success",
    miniName: "ST",
    layout: "",
    // component: <ProtectedRoute requiredRoles={['ROLE_ADMIN']}><SettingsPage /></ProtectedRoute>,
    component: (
        <RulesPage />
    ),
    protected: false,
    adminOnly: false,
  },
];

// Sidebar navigation routes (what appears in the sidebar)
export const sidebarRoutes = [
  {
    path: "/main-menu",
    name: "Main Menu",
    icon: "ni ni-bullet-list-67 text-info",
    miniName: "MM",
    layout: "",
    protected: true,
  },
  {
    path: "/merchants",
    name: "Merchants",
    icon: "ni ni-shop text-info",
    miniName: "M",
    layout: "",
    protected: true,
  },
  // Visual-only example entries (non-functional placeholders)
  {
    path: "/quick-links",
    name: "Quick Links",
    icon: "ni ni-curved-next text-info",
    miniName: "QL",
    navOnly: true,
    protected: false,
  },
  {
    path: "/support",
    name: "Support",
    icon: "ni ni-support-16 text-info",
    miniName: "S",
    navOnly: true,
    protected: false,
  },

  {
    path: "/applications",
    name: "Applications",
    icon: "ni ni-check-bold text-info",
    miniName: "A",
    layout: "",
    protected: true,
  },
  {
    path: "/deals",
    name: "Deals",
    icon: "ni ni-money-coins text-info",
    miniName: "D",
    layout: "",
    protected: true,
  },
  {
    path: "/financial-metrics",
    name: "Reports",
    icon: "ni ni-chart-bar-32 text-info",
    miniName: "FM",
    layout: "",
    protected: true,
  },
  {
    path: "/rules",
    name: "Rules",
    icon: "ni ni-settings text-info",
    miniName: "RC",
    layout: "",
    protected: false, // make true for admin-only access
    adminOnly: false, // make true for admin-only access
  },
];

// Helper function to get protected routes
export const getProtectedRoutes = () => {
  return appRoutes.filter(route => route.protected);
};

// Helper function to get public routes

// Helper function to get all routes (protected + public)
export const getAllRoutes = () => {
  return appRoutes;
};

// Helper function to get sidebar routes
export const getSidebarRoutes = () => {
  return sidebarRoutes.filter(route => !route.navOnly || route.protected);
};


export default appRoutes;
